// Historial de novedades de ConextCRM Ventas (uso interno: comerciales/trabajadores).
// La PRIMERA entrada define APP_VERSION. Al hacer deploy, añade una entrada nueva ARRIBA.
// tag: "novedad" | "mejora" | "arreglo"
export const CHANGELOG = [
  {
    version: "1.73.0",
    date: "2026-10-16",
    title: "«Precio» de autoescuelas: uso estimado de mensajes y precio fijo en la prueba",
    tag: "mejora",
    items: [
      "Debajo del precio sale «Tu uso estimado»: unos 200 mensajes al mes por profesor contra los 1.000 incluidos. Si se pasan, cuánto sería el extra (0,03 € por mensaje) y el total aproximado al mes, con pago mensual y con pago anual (el extra se paga cada mes en los dos). Si no, «Te sobran mensajes».",
      "Siempre visible: si su uso no encaja, durante la prueba gratuita les ajustamos los mensajes incluidos para que tengan un precio fijo que lo cubra todo. Úsalo para quitar el miedo a pagar de más.",
      "Desde 8 profesores sale además «Presupuesto a medida con los mensajes incluidos en la cuota» (antes, desde 16).",
    ],
  },
  {
    version: "1.72.0",
    date: "2026-10-16",
    title: "Simulador de autoescuelas: «Precio», la tarifa según el número de profesores",
    tag: "novedad",
    items: [
      "Nueva entrada «Precio» en el menú del simulador de autoescuelas (encima de Soporte). Pones el número de profesores y sale al momento el precio al mes y el pago anual (pagan 10 meses y tienen 12), con lo que ahorran y lo que incluye.",
      "Tarifa sin IVA: 1 profesor 35 €, 2-3 40 €, 4 45 €, 5 50 €, 6-7 55 €, y desde 8, 5 € más por cada 2 profesores. Con varias sedes o más de 15 profesores, además, presupuesto a medida.",
      "Cuándo enseñarla: cuando en la demo preguntan el precio. Explícalo por encima con la pantalla delante: 1.000 mensajes de WhatsApp al mes incluidos, sin permanencia, 15 días de prueba, alta e importación de alumnos y soporte por WhatsApp y teléfono. La IA del teléfono va aparte: «consúltanos».",
    ],
  },
  {
    version: "1.71.0",
    date: "2026-10-15",
    title: "Simulador de pedidos: tarjeta de fidelidad (cada N pedidos, premio automático)",
    tag: "novedad",
    items: [
      "La app de pedidos tiene ya la tarjeta de fidelidad que pidió José Luis: cada N pedidos entregados del mismo teléfono, el cliente gana un premio (un % de descuento, unos euros o un plato gratis) que se descuenta solo en su siguiente pedido, por WhatsApp, por la web o el que apunta el negocio. El envío y el suplemento a domicilio no se descuentan.",
      "Dónde enseñarlo en el simulador: Ajustes → «Tarjeta de fidelidad» (viene encendida, cada 10 pedidos y 10 %; cambia el premio y mira cómo lo lee el cliente en la vista previa). Luego Pedidos → «Nuevo pedido» con María López (va por el pedido 7 de 10) o con Roberto Fernández (tiene un premio esperando: verás el descuento aplicado y el total rebajado).",
      "En el tablero, el pedido de Laura Gómez lleva el chip verde «Premio de fidelidad», y en su detalle la fila justo encima del Total. La ficha del cliente enseña «Tarjeta de fidelidad 7 de 10» y la confirmación que recibe el cliente lleva su progreso («este es tu pedido 7 de 10»).",
      "A quién vendérselo: al restaurante o negocio de comida para llevar con clientes que repiten (menú diario, cocina casera) y que hoy regala el café o apunta sellos en una cartulina.",
    ],
  },
  {
    version: "1.70.0",
    date: "2026-10-03",
    title: "Simulador de citas: «Sacar dinero» de la caja y lo que debe cada trabajador",
    tag: "novedad",
    items: [
      "La app de citas ya apunta el dinero que se saca del cajón: adelantos a un trabajador (quedan como lo que debe hasta que se le descuente) y gastos del negocio pagados con la caja. Lo pidió BARBER CLUB: sus barberos cogen dinero casi a diario y lo llevaban a mano.",
      "Dónde enseñarlo en el simulador: Calendario → botón «Sacar dinero» (debajo de «Caja»; si abres la caja antes, verás que la retirada resta del efectivo esperado). Luego Administración → Facturación → Todas → «Dinero sacado de la caja»: lo sacado hoy, lo que debe cada barbero con «Saldar» (todo o una parte) y los apuntes con «Anular». Trae tres apuntes de ejemplo para que no salga vacío.",
      "A quién vendérselo: al negocio con varios trabajadores y efectivo en mostrador (barberías, peluquerías) que hoy apunta los adelantos en una libreta. Necesita el Control de caja activado; no hace falta llevar arqueo.",
    ],
  },
  {
    version: "1.69.0",
    date: "2026-09-23",
    title: "El calendario dice en qué quedó cada demo, y al abrirla ves tus notas",
    tag: "mejora",
    items: [
      "Las demos ya cerradas se distinguen en el Calendario sin abrirlas: bandera si está Realizada, € si está Vendida, aspa roja si fue No-show y un guion si se dio por Perdida. La tarjeta se atenúa, porque ya no hay nada que hacer con ella. El tick verde sigue significando otra cosa: que el lead confirmó que asistiría.",
      "Al pulsar una demo cerrada, arriba te dice cómo quedó y cuándo la cerraste, y su botón sale resaltado. Antes se abría igual que una demo nueva, sin nada marcado.",
      "Y si escribiste algo en «Notas de seguimiento» de la ficha del lead, ahora aparece dentro del propio modal. Antes ponía «sin nota» aunque la tuvieras escrita, porque miraba solo la nota de cierre.",
    ],
  },
  {
    version: "1.68.0",
    date: "2026-09-22",
    title: "Calendario: se ve quién ha confirmado la demo, y puedes confirmarla tú",
    tag: "novedad",
    items: [
      "Cada demo del Calendario dice ya si el lead ha confirmado que asistirá: marco verde con un tick si está confirmada, y exclamación roja si no lo está todavía. Pasa el ratón por encima y te lo explica. Solo se marcan en rojo las que aún están por delante.",
      "Si hablas con el lead por teléfono o WhatsApp y te dice que allí estará, pulsa la demo y dale a «Marcar confirmada»: la demo pasa a verde, deja de contar como pendiente y se apaga el aviso automático de «sin confirmar». Queda guardado que la confirmaste tú y cuándo.",
      "La confirmación NO cambia el resultado de la demo: sigues cerrándola en Realizada, Vendida, No-show o Perdida como hasta ahora.",
      "De paso, la sección se ve mejor: manda el nombre del negocio (antes mandaba la hora y el nombre se cortaba), hoy se distingue de un vistazo y en el móvil el calendario abre por día, donde sí se lee la tarjeta entera.",
    ],
  },
  {
    version: "1.67.0",
    date: "2026-09-09",
    title: "Supervisión de pruebas: ahora dice claro si el cliente está usando la app",
    tag: "arreglo",
    items: [
      "«¿Está usando la app?» con respuesta en una frase al abrir las estadísticas: «Sí, la abrió hace 2 días · 17 días de uso en el último mes», «Se está enfriando», «No, lleva X días sin abrirla». En la tarjeta tienes el mismo dato como chip.",
      "Se medía por el último login, y desde que la sesión dura 30 días y se renueva sola, ese dato se queda congelado: AUTOLAVADOS H&A ponía «último acceso: 16 ago» cuando había entrado el día anterior. Ahora se mira cuándo abrió la app de verdad y cuántos días la ha abierto en el último mes (antes solo se veía la última semana).",
      "Corregido también el reparto de citas por canal: decía «45 por WhatsApp · 15 por CRM» en negocios que meten TODAS las citas a mano. Ahora los números son los reales, y se ve de un vistazo quién tiene a sus clientes reservando solos y quién usa el CRM como agenda.",
    ],
  },
  {
    version: "1.66.0",
    date: "2026-09-09",
    title: "Tus notas de seguimiento ya se ven en Mis agendas (y la ficha ya no se abre a medias)",
    tag: "arreglo",
    items: [
      "Lo que escribes en «Notas de seguimiento» de la ficha del lead aparece ahora también en las tarjetas de Mis agendas y en la columna Nota del histórico, con el icono 📝. La nota que pones al cerrar una demo sigue saliendo aparte, con 🏁: son dos cosas distintas y antes solo se veía la segunda, por eso tus comentarios parecían desaparecer.",
      "Arreglado un fallo que podía BORRAR esas notas: si abrías la ficha desde Mis agendas o el Calendario justo mientras cargaba la lista de contactos, el formulario salía en blanco y al pulsar «Guardar cambios» se llevaba por delante lo que habías escrito. Ahora espera a tener la ficha completa antes de abrirla.",
    ],
  },
  {
    version: "1.65.0",
    date: "2026-09-08",
    title: "De dónde salió cada lead: chip de origen en Mis agendas",
    tag: "novedad",
    items: [
      "Cada demo y cada lead pendiente lleva ahora un chip con su origen real: Anuncio Meta (con la campaña y el creativo en el tooltip), Anuncio Google, Campaña WhatsApp (respondió a nuestro envío), Flow enviado por un vendedor (con su nombre), Llamada en frío, Escribió por WhatsApp, Referido, Landing orgánica o Alta manual.",
      "Manda la FUENTE del lead, no cómo se agendó: un negocio de la lista que contestó a la campaña de WhatsApp y al que Trini agendó a mano sale como «Campaña WhatsApp», no como «Llamada en frío».",
      "El mismo chip aparece en las tarjetas del tablero, en la bandeja de pendientes y en la columna Origen del histórico.",
    ],
  },
  {
    version: "1.64.0",
    date: "2026-09-08",
    title: "Mis agendas: columna «Seguimiento» · Supervisión: las empresas que ya pagan se ven de lejos",
    tag: "mejora",
    items: [
      "Nueva columna «Seguimiento» en el tablero de Mis agendas, entre Agendadas y Por cerrar: las demos ya realizadas que todavía no has cerrado en vendida o perdida. Es la negociación abierta; antes solo se veían buscando en el histórico (lo pidió Trini la primera mañana).",
      "En Supervisión de pruebas, las empresas con suscripción activa llevan marco esmeralda con un brillo suave, y las que ya han puesto la tarjeta (primer cobro pendiente) marco teal. Se distinguen sin leer el chip.",
    ],
  },
  {
    version: "1.63.0",
    date: "2026-09-08",
    title: "Mis agendas: tablero por etapas con «Hoy» arriba, y rescate automático de no-shows",
    tag: "novedad",
    items: [
      "Arriba del todo, «Hoy»: tus demos y llamadas de hoy con la hora, el Meet y el botón de resultado. Es lo que necesitas a las 9 de la mañana y antes había que deducirlo de la tabla.",
      "Debajo, un tablero con solo lo vivo, en cuatro columnas: Por contactar (pidieron demo o llamada y nadie les ha escrito) → Contactado (responde / no responde) → Agendadas (a partir de mañana) → Por cerrar (celebradas sin resultado, en rojo, y no-shows recientes). Las tarjetas se mueven con botones, no arrastrando: en el móvil funciona igual de bien.",
      "Cuando una demo acaba en vendida, perdida o no corresponde, desaparece del tablero. La tabla de siempre, con contadores y filtros, sigue debajo en «Histórico y estadísticas», plegada.",
      "Los no-shows ya no se pierden: al día siguiente el lead recibe por WhatsApp un mensaje de tu parte («te habías reservado 30 minutos… ¿qué pasó? elige otro hueco») y, si no reacciona, otro a los 4 días. Todo automático. Si el lead reagenda, entra por el camino normal y te llega el aviso de Telegram.",
      "En la tarjeta del no-show, el chip lila («Rescate automático en marcha» / «Rescate F1 enviado») se puede pulsar: te abre una vista previa con los dos mensajes exactos que le llegan al lead, con su nombre y su fecha, cuándo sale cada uno y cuándo se corta. Así sabes qué está haciendo el sistema por ti y no escribes encima.",
    ],
  },
  {
    version: "1.62.0",
    date: "2026-08-05",
    title: "Simulador de lavadero: servicios «a presupuesto»",
    tag: "novedad",
    items: [
      "El simulador de lavadero (modo by_service) ya enseña los servicios «a presupuesto»: en el editor de un servicio tienes el interruptor ámbar «Este servicio se da a presupuesto», con su ojo para ver cómo lo vive el cliente.",
      "Al reservar por WhatsApp en la demo, un servicio marcado sale como «Presupuesto · <nombre>» (sin precio) y, al elegirlo, el cliente NO reserva hora: pasa a la pantalla «Solicitar presupuesto 📋» (un campo de texto libre) y recibe el mismo acuse que en producción — «✅ Recibido. Te enviaremos el presupuesto por aquí lo antes posible.».",
      "Te sirve para vender a lavaderos con servicios que no tienen un precio cerrado — autocaravanas, flotas, coches de empresa —: en vez de forzar un precio de catálogo, el cliente cuenta qué necesita y el negocio le pasa el presupuesto por WhatsApp.",
    ],
  },
  {
    version: "1.61.0",
    date: "2026-08-05",
    title: "Del chat vuelves a la ficha de un clic, y marcas los leads que llevas por tu WhatsApp",
    tag: "mejora",
    items: [
      "Volver a la ficha del lead ya no cuesta cuatro pasos. Cuando entras al chat desde la ficha (el botón «Ir al chat»), arriba a la izquierda del chat te aparece una flecha ←: la pulsas y vuelves a la MISMA ficha que tenías abierta, sin pasar por Contactos ni buscar el lead otra vez.",
      "Nuevo distintivo «Lo gestiono yo» en la cabecera del chat: cuando un lead responde a la publicidad del número general y sigues la conversación desde TU WhatsApp de empresa, lo marcas ahí y queda registrado con tu nombre y la fecha. Se quita pulsando otra vez.",
      "El distintivo se ve también en la lista de chats, al lado del nombre del lead: de un vistazo se sabe qué leads ya está atendiendo alguien y cuáles siguen sin tocar. Así nadie tiene que preguntar «¿has visto este chat?» y no se pierden leads por creer que ya los llevaba otro.",
    ],
  },
  {
    version: "1.60.0",
    date: "2026-07-29",
    title: "Llamada de configuración (llamada 2): agéndala desde la ficha del lead",
    tag: "novedad",
    items: [
      "Tras una demo que va bien, la práctica habitual es una segunda videollamada de configuración para pasarle los accesos al cliente y dejarle el negocio en marcha. Ya se agenda desde el CRM: en la ficha del lead → columna «Demo» tienes el bloque «Llamada de configuración» — eliges asesor, fecha y hora y listo. Bloquea el hueco real en tu calendario (la landing ya no lo ofrece) y el lead recibe confirmación y recordatorios 24 h y 2 h antes por WhatsApp, con tu nombre y TU WhatsApp para cambios, igual que la demo.",
      "En «Mis agendas» las ves separadas: columna «Tipo» con chip Demo / Configuración y filtro propio. Las llamadas de configuración NO cuentan en tus estadísticas de demos (agendadas, realizadas, conversión): son puesta en marcha, no pipeline.",
      "Al lado de agendar (también en «Agendar demo») tienes el ojo de siempre: vista previa exacta del WhatsApp que recibirá el lead — la confirmación y el recordatorio con el botón «Confirmar cita» — con tu nombre, la fecha y tu número reales.",
      "Gestión completa desde la misma card: Realizada, No-show, Reagendar (mueve el hueco y los recordatorios solos) y Cancelar (libera el hueco sin descartar al lead).",
    ],
  },
  {
    version: "1.59.0",
    date: "2026-07-27",
    title: "Mandar el enlace de la videollamada por email, desde la ficha del lead",
    tag: "novedad",
    items: [
      "Herramienta para vosotros, no para vender: cuando un lead pide la invitación de la videollamada por correo en vez de por WhatsApp, ya no hay que pedírselo a nadie. En la ficha del lead → columna «Demo» tienes el botón «Enviar enlace de videollamada»: pegas el enlace de Google Meet, confirmas el correo (viene puesto el del lead) y se envía al momento.",
      "El correo sale con el logo de ConextCRM, el día y la hora de la demo que tenga agendada, un botón grande «Entrar a la videollamada» y, al final, un botón verde de WhatsApp con TU número — el lead que tenga una duda antes de la llamada te escribe a ti directamente, no al número general.",
      "Como en el resto de envíos, al lado tienes el ojo: ábrelo y ves exactamente el correo que le va a llegar antes de mandarlo. Queda registrado en la ficha del lead (fecha, correo y enlace enviados).",
    ],
  },
  {
    version: "1.58.0",
    date: "2026-07-16",
    title: "Control de caja también en la app de citas",
    tag: "novedad",
    items: [
      "La caja (aperturas, cierres y arqueo) ya no es solo de la app de pedidos: ahora también se gestiona en la de citas. El negocio abre el turno desde el calendario, cobra cada cita en efectivo/tarjeta/mixto (importe editable, productos del almacén y factura opcional en el mismo paso) y al cerrar cuadra el efectivo con el descuadre calculado.",
      "Dónde enseñarlo en el simulador: Calendario → botón «Caja» (abrir/cerrar) y pulsar una cita → «Cobrar». El interruptor está en Configuración → «Control de caja». Si cobras un pedido y una cita, verás que suman al MISMO arqueo: es una sola caja.",
      "A quién vendérselo: es OPCIONAL y por empresa. Encaja en el negocio que da citas desde el CRM y cobra en mostrador (peluquerías, estética). Al que todas las citas le entran por WhatsApp y no crea ninguna a mano, no le aporta — no se lo vendas por vender.",
    ],
  },
  {
    version: "1.57.0",
    date: "2026-07-14",
    title: "Fichar por WhatsApp: el equipo ficha enviando «fichar»",
    tag: "novedad",
    items: [
      "Nueva función para vender: los trabajadores del negocio fichan su entrada y salida enviando «fichar» por WhatsApp, sin apps ni contraseñas. El sistema detecta solo si toca entrada o salida, admite selfie antifraude y funciona por el número de Conext o por el propio del negocio. Cumple el registro de jornada (hora sellada por el servidor, historial exportable).",
      "Dónde enseñarlo en el simulador: sección «Fichajes» → botón «Ver cómo funciona» (mockups de WhatsApp de cada caso —entrada/salida, turno partido, selfie— y el número exacto al que se escribe) y el interruptor «Fichar por WhatsApp» en Configuración.",
      "Pitch: «Tu equipo ficha sin relojes ni fichas: solo escriben «fichar» al WhatsApp del negocio y listo. Y si quieres, con foto para que sepas que fichó quien tenía que fichar.»",
    ],
  },
  {
    version: "1.56.0",
    date: "2026-07-13",
    title: "Enlace de reserva: guía «¿Por dónde empiezo?» con vistas previas",
    tag: "mejora",
    items: [
      "El botón «Ver enlace de reserva» (en el calendario) trae ahora una guía visual que anima al negocio a poner su link de reservas por WhatsApp donde están sus clientes, con vistas previas fieles de cada sitio. Tres canales explicados solos: lista de difusión de WhatsApp, redes sociales (Instagram y Facebook) y Google Maps / su ficha de Google.",
      "Fricción cero: para la difusión de WhatsApp le damos un mensaje ya redactado y listo para copiar y enviar a todos sus clientes (con el enlace dentro); para redes y Google, un botón de «Copiar enlace» y hasta un texto sugerido para el post. Cada canal muestra un mockup de cómo queda (la pantalla de difusión, la bio de Instagram con el enlace, la ficha de Google con el botón «Reservar»).",
      "Pitch para la demo: «El enlace ya lo tienes; ahora te decimos exactamente por dónde empezar para que tus clientes reserven solos — lo pegas en tu Instagram, en tu Google y se lo mandas a todos por WhatsApp en un minuto». Todo se reserva por WhatsApp, no por un formulario online.",
    ],
  },
  {
    version: "1.55.1",
    date: "2026-07-13",
    title: "Anticipos: chip € en el calendario del simulador",
    tag: "mejora",
    items: [
      "Las citas demo con anticipo del simulador muestran ahora el chip € en la esquina (verde = pagado, ámbar = pendiente), y al reembolsar desde la cita el estado pasa a «Anticipo reembolsado». Detalle bonito para la demo: «mira, de un vistazo sabes qué citas ya están pagadas».",
    ],
  },
  {
    version: "1.55.0",
    date: "2026-07-11",
    title: "Anticipo de pago para reservar, en el simulador (citas)",
    tag: "novedad",
    items: [
      "Nueva función estrella para vender en sectores de citas: el negocio puede exigir una señal (anticipo) pagada online para confirmar la reserva de servicios concretos — pensado para servicios largos o caros (mechas, tratamientos, alisados) donde un plantón duele. El cliente reserva por WhatsApp, recibe un enlace de pago seguro (Stripe) y la cita solo se confirma al pagar; el negocio elige qué pasa si no paga: mantener la cita igualmente o liberar el hueco a los X minutos avisando al cliente.",
      "Dónde enseñarlo en el simulador: Configuración → tarjeta «Cobros online» (activación simulada + política de impago), editor de servicios → «Pedir anticipo online» con su importe y el chip «Anticipo X€» en la tarjeta del servicio, y el calendario trae dos citas demo con los estados «Anticipo pendiente» y «Anticipo pagado» (con botón de reembolso).",
      "El as en la manga para la demo: el icono del ojo junto al anticipo abre una vista previa animada en un móvil con el recorrido completo del cliente — mensaje de WhatsApp con el enlace, pago en Stripe, pantalla de éxito y confirmación con ticket. Se explica sola.",
      "Pitch: «¿Te dejan tirado con las mechas? Pide una señal de 10€ al reservar y olvídate de los plantones. Si no paga en 10 minutos, el hueco se libera solo.» En la app real ya está en producción con Stripe real (comisión por cobro incluida).",
    ],
  },
  {
    version: "1.54.0",
    date: "2026-07-11",
    title: "Resumen de funciones para autoescuela en el simulador",
    tag: "novedad",
    items: [
      "El botón «Ver resumen» del simulador ya está disponible en el sector Autoescuela, con su propio resumen adaptado: planificación de prácticas y envío por WhatsApp (con recordatorios automáticos 24 h y 2 h antes), ficha del alumno completa, exámenes y convocatorias con consumo automático de tasas DGT, seguimiento de la teórica, contrato de matrícula digital (firma en pantalla + PDF), flota de vehículos con avisos de vencimiento, pagos y packs con cobro online por tarjeta (Stripe), facturación con VeriFactu, y mensajes automáticos por WhatsApp.",
      "Incluye la banda de «Campañas que te proponemos» adaptada a autoescuela (pedir una reseña en Google al aprobar, captar alumnos por recomendación): se las proponemos nosotros, no las monta el cliente.",
      "Úsalo para cerrar la demo de una autoescuela. De momento en español.",
    ],
  },
  {
    version: "1.53.0",
    date: "2026-07-11",
    title: "Resumen de funciones para comida para llevar en el simulador",
    tag: "novedad",
    items: [
      "El botón «Ver resumen» del simulador ya está disponible en el sector Comida para llevar, con su propio resumen adaptado a pedidos: pedidos por WhatsApp sin intervención (con el tablero recibido → preparando → listo → entregado), carta digital que se difunde por WhatsApp, Instagram y Facebook, cobro online y TPV de mostrador con cierre de caja, mensajes automáticos del pedido (confirmación, vuelve a pedir, reseña en Google…), ficha de clientes, facturación con VeriFactu, fichaje y «el día de un vistazo».",
      "Igual que en citas, incluye la banda de «Campañas que te proponemos» (la oferta del día, avisar que cierra por vacaciones, pedir reseña en Google): se las proponemos nosotros, no las monta el cliente.",
      "Úsalo para cerrar la demo de un negocio de comida para llevar. De momento en español.",
    ],
  },
  {
    version: "1.52.0",
    date: "2026-07-10",
    title: "Resumen de funciones por sector en el simulador",
    tag: "novedad",
    items: [
      "Nuevo botón «Ver resumen» en el simulador (sectores de citas), en la misma fila que «Salir del simulador», debajo de Soporte: abre un resumen visual de las funciones y beneficios de ConextCRM adaptado al sector del cliente. Con textos propios para barbería, peluquería, estética y lavadero; el resto de sectores de citas ven un resumen genérico.",
      "Pensado para cerrar la demo: de un vistazo repasas todo lo que se lleva el negocio — reservas por WhatsApp sin intervención, recordatorios, todos los mensajes automáticos con su beneficio, ficha de clientes, facturación con VeriFactu, fichaje de trabajadores, bonos de fidelidad, almacén y las campañas que le iremos proponiendo (avisar a sus clientes cuando cierra por vacaciones y cuando vuelve para que le reserven, etc.).",
      "El texto está personalizado por sector para que suene al oficio del cliente. De momento en español.",
    ],
  },
  {
    version: "1.51.0",
    date: "2026-07-10",
    title: "Recolocar citas canceladas: nuevas citas por WhatsApp",
    tag: "novedad",
    items: [
      "Novedad para enseñar al cliente: en «Mensajes automáticos» hay una tarjeta nueva, «Recolocar citas canceladas». Cuando el negocio cancela un tramo de citas desde «Cancelación masiva», el sistema ofrece automáticamente a cada cliente un hueco nuevo lo más parecido posible a su cita original (mismo profesional y franja horaria) en los días siguientes, por WhatsApp, con botones «Sí, quiero esta cita» / «No, gracias».",
      "Pitch de venta: «¿Y qué hacemos con las citas anuladas? Lo hemos resuelto: ofrecemos nuevas citas por WhatsApp en el tramo horario más parecido posible. Tu tiempo es oro.» Pruébalo en el simulador (sectores de citas): la tarjeta está en «Mensajes automáticos», con una animación de cómo se recolocan las citas.",
    ],
  },
  {
    version: "1.50.0",
    date: "2026-07-08",
    title: "Seguimiento de demos desde la ficha del lead",
    tag: "novedad",
    items: [
      "Nueva sección Demo dentro de la ficha del lead: resultado, notas y reagendar, todo en un mismo sitio, sin salir de la ficha.",
      "Aviso claro cuando hay una demo pendiente de registrar resultado, para no dejarla suelta.",
    ],
  },
  {
    version: "1.49.0",
    date: "2026-07-08",
    title: "Notificaciones de nuevas reservas: sonido, aviso y campanita",
    tag: "novedad",
    items: [
      "Novedad para enseñar al cliente: cuando un cliente suyo reserva una cita (por WhatsApp o por el enlace de reservas), la app le avisa al momento: suena una notificación y aparece un aviso con los detalles de la cita y un botón «Ver cita» que le lleva al calendario, al día de la cita, y se la resalta para verla de un vistazo.",
      "Nueva campanita en el menú lateral: es el centro de notificaciones. Ahí queda el historial de las últimas reservas recibidas, con acceso directo a cada cita, y se puede silenciar el sonido cuando quiera.",
      "El aviso solo lo ve el administrador y requiere tener la app abierta. Las citas que crea él mismo desde el calendario no generan aviso. Puedes probarlo en el simulador (sectores de citas): la campanita está arriba en el menú lateral.",
    ],
  },
  {
    version: "1.48.0",
    date: "2026-07-03",
    title: "Supervisión de pruebas: semáforo de actividad y métricas por sector",
    tag: "mejora",
    items: [
      "Cada lead lleva ahora un semáforo (🟢 Activo / 🟡 Tibio / 🟠 Frío / 🔴 Sin arrancar) calculado automáticamente: de un vistazo sabes quién usa la app y a quién hay que rescatar, sin analizar números.",
      "Los negocios de comida (restaurantes, comida para llevar, bares…) muestran sus métricas reales: pedidos, reservas de mesa, caja y carta configurada — ya no aparecen con «0 citas».",
      "Chip de sector en cada tarjeta y nuevos filtros por sector y por actividad, más orden «Peor primero» para atacar los rojos. Nueva tarjeta arriba: «Sin arrancar / fríos».",
      "El panel carga al instante aunque haya cientos de leads (datos precalculados cada noche) y mide la frecuencia real de uso («Entra 5/7 días»).",
    ],
  },
  {
    version: "1.47.0",
    date: "2026-06-30",
    title: "Las demos que reserva el cliente por WhatsApp entran en el sistema de demos",
    tag: "mejora",
    items: [
      "Cuando un lead reserva su presentación desde el WhatsApp (botón «Solicitar presentación» del Flow), esa demo ya no se queda solo en el calendario: entra en el sistema unificado de demos como «Autoagendada (flow)», con su modalidad (online o presencial).",
      "Aparece en «Solicitudes de demo» con un chip propio «Autoagendada» (distinto de Televenta y de las de la web), mostrando el día/hora, la modalidad y el closer que la atiende.",
      "Cuenta en las métricas de la sección «Televenta» como cohorte propia «Autoagendadas (flow)» (no se mezcla con la conversión del embudo de televenta), y suma al closer correspondiente.",
      "Estas demos no tienen cold caller (las reserva el propio cliente desde el WhatsApp): la comisión, si se cierra la venta, es del closer que la atiende.",
    ],
  },
  {
    version: "1.46.0",
    date: "2026-06-30",
    title: "Flow de ventas: variante «full online» para televenta",
    tag: "mejora",
    items: [
      "En la vista previa del Flow («Enviar Flow») hay un nuevo selector «Presencial / Full online (televenta)». En modo online el mensaje de presentación ya no dice que un asesor pasará por el negocio, sino que se le contactará por teléfono y la demo es online, sin visitas (igual que ya hacía comida para llevar).",
      "Para los leads marcados como «Lead de televenta», el envío del Flow usa automáticamente la variante online: la cabecera con el cierre «te llamaremos / todo online» y el botón «Solicitar presentación» abre directamente la reserva de videollamada (sin preguntar presencial u online: en televenta es online siempre).",
      "La vista previa del formulario de «Solicitar presentación» también refleja el modo online: salta la pregunta de modalidad y muestra «Reserva tu videollamada online».",
    ],
  },
  {
    version: "1.45.0",
    date: "2026-06-30",
    title: "Televenta: agenda de demos del cold caller al closer, con métricas y trazabilidad",
    tag: "novedad",
    items: [
      "Nuevo modo televenta para captación telefónica: al crear o editar un lead puedes marcarlo como «Lead de televenta». En ese modo el lead se simplifica (se ocultan los campos presenciales de tablet y visita) y aparece un bloque «Cold call» con la disposición de la llamada (No contesta / Volver a llamar / No interesado / ¡Agendada!).",
      "Cuando el cold caller marca «¡Agendada!», agenda la demo a un closer (hoy Trini) eligiendo fecha y hora. La demo le llega al closer en su Calendario, en sus Tareas y en «Solicitudes de demo», y al closer le entra un aviso por WhatsApp.",
      "El closer marca el resultado de cada demo (Realizada, No-show, Reagendar, Vendida, Perdida) desde el calendario. Si sale No-show o Perdida, se crea automáticamente una tarea de seguimiento al cold caller que la consiguió, para que la recontacte.",
      "Cada cold caller tiene su pantalla «Mis agendas» con el estado de todas las demos que ha pasado al closer (agendadas, realizadas, vendidas, no-show…).",
      "Trazabilidad para comisiones: en cada agenda se ve claramente de qué cold caller viene (en Solicitudes, en el calendario y en el resultado de la demo), para poder liquidar comisiones después.",
      "Las solicitudes que llegan de la landing (autoagenda y «que me llamen») entran directas al closer como demos inbound, sin cold caller, y también cuentan en las métricas (separadas del canal televenta).",
      "Nueva sección «Televenta»: agendas por cold caller, demos realizadas y convertidas por closer, tasa de show-up y de conversión, con desglose televenta vs inbound y filtro por fechas.",
    ],
  },
  {
    version: "1.44.0",
    date: "2026-06-29",
    title: "Listas de espera (barberías, peluquerías y estética)",
    tag: "novedad",
    items: [
      "Nueva función en la app de citas para barberías, peluquerías y estética: si un día está completo, el cliente puede apuntarse a una lista de espera por WhatsApp y, cuando se libera un hueco que le encaja, recibe la oferta de la cita automáticamente (con «Sí, la quiero» / «No, gracias»); si acepta, la cita se crea sola.",
      "Argumento de venta: ningún hueco se queda vacío y el negocio no pierde al cliente por no haber sitio ese día. Se avisa de uno en uno por orden de llegada y, si nadie responde, entra «Rellenar huecos por cancelación».",
      "El dueño lo activa y configura en Administración → Mensajes automáticos → «Lista de espera» (tiempo de respuesta, máximo avisados, días vista) y tiene una pantalla para ver y gestionar quién está apuntado cada día. Solo se ofrece en días que trabaja: festivos, vacaciones y días cerrados no se ofrecen.",
    ],
  },
  {
    version: "1.43.0",
    date: "2026-06-26",
    title: "Citas desde el CRM: libertad para solapar (el sistema avisa, pero no bloquea)",
    tag: "novedad",
    items: [
      "En la app de citas, al crear una cita desde el calendario (haciendo clic en un hueco), el dueño del negocio ya puede meter la cita donde quiera aunque se solape con otra o no quepa en lo que queda del turno. El sistema le avisa del solape, pero le deja continuar y crearla igualmente: él decide.",
      "Antes esto le bloqueaba: si el hueco estaba ocupado o no cabía, no podía avanzar. Ahora aparece un aviso con el botón «Continuar de todas formas» (y se le recuerda en el paso de confirmar antes de crearla).",
      "Aplica a todos los sectores con citas y calendario: peluquerías, barberías, estética, lavaderos, spa, fisioterapia, salud, etc.",
      "Importante para vender con tranquilidad: las reservas que hacen los CLIENTES por WhatsApp o por el formulario web siguen respetando la disponibilidad (no se solapan). La libertad de solapar es solo para el dueño desde el CRM.",
      "Demostrable en el simulador: en el calendario, haz clic en un hueco ya ocupado por otra cita, elige servicio y pulsa Continuar; verás el aviso de solape y el botón «Continuar de todas formas».",
    ],
  },
  {
    version: "1.42.0",
    date: "2026-06-26",
    title: "Horarios especiales por fechas: el «horario de agosto» (demostrable en el simulador)",
    tag: "novedad",
    items: [
      "Nueva función en la app de citas: cada trabajador puede tener horarios especiales para un rango de fechas (p. ej. agosto solo por las mañanas, o cerrado por vacaciones), aparte de su horario semanal normal. Es justo lo que piden los negocios que cambian de horario en verano.",
      "Argumento de venta: hasta ahora el horario era el mismo todo el año; si en agosto abrían distinto, no había forma de configurarlo. Ahora sí, y las reservas (WhatsApp y CRM) respetan automáticamente ese horario solo en esas fechas.",
      "Cómo demostrarlo en el simulador: Configuración → «Horario comercial y trabajadores» → «Configurar Horario» de un trabajador → pestaña «Horarios especiales» → «Añadir periodo especial»: elige las fechas (p. ej. 1–31 de agosto), marca los días y las franjas (por ejemplo solo mañanas) y guarda. Los días que no marques quedan cerrados, y al reabrir verás el periodo guardado en la lista.",
      "Enséñale que puede tener varios periodos (varios meses), editarlos o borrarlos, y que con «Copiar a todos los trabajadores» aplica el mismo agosto a toda la plantilla de golpe.",
    ],
  },
  {
    version: "1.41.0",
    date: "2026-06-23",
    title: "Lavaderos: buscar al cliente por la matrícula del coche",
    tag: "novedad",
    items: [
      "Para los clientes del sector lavadero, en la app de citas ya se puede buscar a un cliente por la matrícula de uno de sus vehículos, además de por nombre o teléfono. Funciona en todos los buscadores de cliente (crear cita, facturar, ficha de clientes, venta de almacén, etc.).",
      "Acepta la matrícula con o sin espacio, en mayúsculas o minúsculas, e incluso solo un trozo; en los resultados se muestra la matrícula que ha coincidido.",
      "Lo tienes disponible en el simulador (sector lavadero) para enseñárselo al cliente: busca por ejemplo «4823 KJT» o «4823kjt» y verás cómo aparece su dueño.",
    ],
  },
  {
    version: "1.40.0",
    date: "2026-06-23",
    title: "Vender la tablet al cliente (100 €, en efectivo o a su cuenta)",
    tag: "novedad",
    items: [
      "En la ficha de un lead que tenga la tablet entregada, ahora aparece el botón «Marcar como vendida». Sirve para cuando el cliente se queda la tablet: por defecto son 100 €, pero puedes cambiar el importe.",
      "Al marcarla eliges la forma de pago: «Efectivo» (te paga en mano) o «Cargar a su cuenta», que se le suma a su próxima factura mensual.",
      "Al «Guardar cambios», el lead deja de constar como «tablet entregada» y pasa a «Tablet vendida», mostrando el importe, la forma de pago y la fecha. Se cancelan automáticamente las 2 tareas de seguimiento de la tablet (la de los 10 y la de los 28 días), porque el cliente ya se la ha quedado.",
      "Si te equivocas, desde el panel «Tablet vendida» puedes revertir la venta y volver a contarla como entregada.",
    ],
  },
  {
    version: "1.39.0",
    date: "2026-06-23",
    title: "Consumo interno del almacén: gasto vs venta (demostrable en el simulador)",
    tag: "novedad",
    items: [
      "Nueva función en el Almacén: una pestaña «Consumo interno» para registrar el producto que el negocio USA pero NO vende (gasto): producto gastado en un servicio, en limpieza, mermas/roturas/caducados o lo que se queda el dueño. Hasta ahora solo se registraban las ventas.",
      "El argumento de venta: su gestoría necesita distinguir lo que compra para vender (ingreso) de lo que es gasto. Ejemplo claro para el cliente: compra 4 secadores, pone 3 a la venta (ingreso) y 1 se lo queda para el local (gasto). Ahora ese 1 queda registrado y sale en el Excel de la gestoría como «Consumo interno», valorado al coste y separado del total de ventas.",
      "Cómo demostrarlo en el simulador: Almacén → pestaña «Consumo interno» → «Registrar consumo», elige producto, cantidad y motivo (uso en servicio / limpieza / merma / autoconsumo); enseña cómo baja el stock solo. También puedes darlo de baja escaneando, con el nuevo modo «Consumo interno» del escáner.",
      "Remátalo en «Facturación → Enviar a gestoría»: el desglose muestra «Consumo interno» como una línea de gasto aparte de las ventas. Y si te equivocas, al borrar el registro el stock se devuelve solo.",
    ],
  },
  {
    version: "1.38.0",
    date: "2026-06-19",
    title: "La primera confirmación invita al cliente a reservar por WhatsApp",
    tag: "mejora",
    items: [
      "Cuando le das la PRIMERA cita a un cliente y la confirmación sale desde el número de Conext, el mensaje añade una línea invitándole a reservar sus próximas citas por ese mismo número.",
      "A partir de la segunda cita, el cliente recibe la confirmación normal.",
    ],
  },
  {
    version: "1.37.0",
    date: "2026-06-19",
    title: "Devolución de tablet: registra por qué te la devuelven",
    tag: "novedad",
    items: [
      "En la ficha de un lead que tenga la tablet entregada, ahora aparece el botón «Ha devuelto la tablet». Al pulsarlo te pide un motivo (por qué la ha devuelto) y, al «Guardar cambios», el lead deja de constar como «tablet entregada» y pasa a mostrar «Tablet devuelta» con su fecha y el motivo.",
      "Así sabemos en todo momento qué tablets ya están de vuelta con el comercial y por qué se devolvieron. Si más adelante se la vuelves a entregar, basta con reactivar «Tablet entregada».",
      "Al registrar la devolución se cancelan automáticamente las 2 tareas de seguimiento de la tablet (la de los 10 días y la de los 28 días), porque ya no hay tablet que seguir.",
      "En «Supervisión de pruebas» verás el estado «Tablet devuelta» en cada lead y un nuevo filtro «Devueltas» para localizar de un vistazo las tablets recuperadas.",
    ],
  },
  {
    version: "1.36.0",
    date: "2026-06-19",
    title: "Intervalo de citas configurable (demostrable en el simulador)",
    tag: "novedad",
    items: [
      "El cliente puede elegir cada cuánto se ofrecen los huecos de reserva (5–60 minutos, por defecto 15). Útil para negocios con servicios de duración fija, p. ej. una hora: solo se ofrecen 10:00, 11:00, 12:00…",
      "En el simulador puedes enseñarlo: cámbialo en Configuración del negocio → «Intervalo de citas» y verás cómo cambian los huecos en el calendario de reserva.",
    ],
  },
  {
    version: "1.35.0",
    date: "2026-06-18",
    title: "Envío de factura por WhatsApp al cliente: reactivado en citas, almacén y bonos",
    tag: "novedad",
    items: [
      "Al generar una factura (ticket o factura A4) de una cita, una venta del almacén o un bono, aparece una opción para marcar: «Enviar la factura al cliente por WhatsApp». Al marcarla, el cliente recibe su factura en PDF directamente en su WhatsApp.",
      "Funciona también durante el periodo de prueba. En el simulador puedes enseñarlo en las demos, y con el ojo de vista previa muestras cómo le llega el mensaje al cliente.",
    ],
  },
  {
    version: "1.34.0",
    date: "2026-06-18",
    title: "Simulador: demostrar la foto al fichar (antifraude)",
    tag: "novedad",
    items: [
      "El simulador de demo ya incluye la «Foto al fichar»: una opción de antifraude que permite que el trabajador se haga un selfie al marcar la entrada o salida, para que el administrador compruebe que fichó la persona correcta.",
      "Cómo demostrarlo: en el simulador, ve a Fichajes → activa el modo «Foto al fichar» en la configuración → ficha desde el kiosko o desde «Mi fichaje» (el flujo te pide permiso de cámara y captura el selfie) → abre el historial y verás el chip «con foto» en el registro; al pulsarlo se abre el preview de la imagen.",
      "Puntos de venta a remarcar al cliente: la foto se borra sola a los 90 días, sin reconocimiento facial ni bases de datos externas, solo la ve el administrador. Si algún dispositivo no tiene cámara, el trabajador puede fichar igualmente (modo opcional).",
    ],
  },
  {
    version: "1.33.0",
    date: "2026-06-18",
    title: "Eliminar contactos: ahora van a la Papelera",
    tag: "novedad",
    items: [
      "Ya puedes seleccionar uno o varios contactos (con la casilla de cada tarjeta) y enviarlos a la Papelera con el botón de la papelera de la barra inferior. Antes esa opción solo la tenía el administrador.",
      "Los contactos enviados a la Papelera salen de su lista y aparecen en una lista \"Papelera\" al final del todo. Desde ahí puedes \"Recuperar\" cualquiera y vuelve a su lista original: no se pierde nada.",
      "El borrado definitivo lo sigue haciendo solo el administrador, revisando la Papelera. Así evitamos borrar por error contactos que luego hagan falta.",
    ],
  },
  {
    version: "1.32.0",
    date: "2026-06-17",
    title: "Exportar facturación ahora vive dentro de Facturación",
    tag: "mejora",
    items: [
      "Hemos simplificado el menú: \"Exportar facturación\" ya no es una sección aparte. Ahora está dentro de Facturación, en una nueva pestaña \"Enviar a gestoría\" (junto a Todas, Citas, Almacén y Bonos).",
      "Igual que el envío de fichajes está dentro de Fichajes, todo lo de la facturación queda en un solo sitio.",
      "Cómo demostrarlo: en el simulador, Administración → Facturación → pestaña \"Enviar a gestoría\".",
    ],
  },
  {
    version: "1.31.0",
    date: "2026-06-17",
    title: "Enviar los fichajes de los trabajadores a la gestoría laboral",
    tag: "novedad",
    items: [
      "El historial de fichajes ya no solo se descarga en Excel: ahora se puede enviar directamente a la gestoría por correo o por WhatsApp, igual que la facturación. Pensado para la gestión laboral (registro horario).",
      "Si el negocio tiene varias gestorías, al enviar se abre el mismo selector que en facturación, pero esta vez deja preseleccionada la gestoría de ámbito Laboral (que es la que lleva los fichajes). Si solo hay una, se envía directo.",
      "Cómo demostrarlo: en el simulador, Fichajes → Ver historial → \"Enviar a gestoría por correo / WhatsApp\". El envío por WhatsApp del cliente real requiere que Meta apruebe antes la plantilla nueva.",
    ],
  },
  {
    version: "1.30.0",
    date: "2026-06-17",
    title: "Varias gestorías: separa los envíos (fiscal y laboral)",
    tag: "novedad",
    items: [
      "Ahora un negocio puede guardar varias gestorías, no solo una. Es justo lo que piden las empresas medianas y grandes, que suelen tener una gestoría para lo fiscal y otra para lo laboral, cada una con su nombre y sus datos de contacto.",
      "A cada gestoría se le pone un nombre para identificarla y se le marca su ámbito (Fiscal, Laboral o ambos). Se gestionan desde el perfil de empresa, en la sección \"Gestorías\".",
      "Cuando el negocio tenga más de una y vaya a enviar la facturación (por correo o WhatsApp), el sistema le pregunta en una ventana sencilla a cuál quiere enviarla, dejando preseleccionada la gestoría fiscal. Si solo tiene una, se envía directo como hasta ahora.",
      "Cómo demostrarlo: en el simulador, Exportar facturación → al pulsar enviar verás el selector de gestoría. El máximo es de 5 gestorías por negocio (si alguien necesitara más, se solicita a soporte).",
    ],
  },
  {
    version: "1.29.0",
    date: "2026-06-16",
    title: "Argumento de venta: control de almacén con lector de códigos de barras",
    tag: "novedad",
    items: [
      "ConextCRM ya permite usar un lector de códigos de barras USB en el Almacén, como los de cualquier tienda. Se enchufa al ordenador y funciona sin instalar nada (el lector actúa como un teclado). Muchos negocios con inventario (peluquerías y estéticas que venden producto, lavaderos, tiendas) ya trabajan así con otros programas: ahora no tienen que cambiar de sistema para tenerlo.",
      "Tres usos con los que cerrar la venta: dar entrada de mercancía (escaneas lo que llega y suma stock solo), vender en mostrador (escaneas lo que se lleva el cliente y se genera la factura descontando el stock) y localizar cualquier producto al instante. Además, los productos se etiquetan solos: la primera vez que escaneas uno, el sistema pregunta a cuál pertenece el código y lo guarda.",
      "Cómo demostrarlo: en el simulador, Almacén → \"Modo escáner\". Si no tienes lector a mano, teclea el código de barras de un producto demo y pulsa Enter: verás cómo lo reconoce igual que con el lector. El panel incluye un bloque \"¿Cómo funciona?\" que le explica al cliente que basta con enchufar un lector USB barato.",
    ],
  },
  {
    version: "1.28.0",
    date: "2026-06-16",
    title: "Argumento de venta: fichaje de trabajadores legal (sin biometría)",
    tag: "novedad",
    items: [
      "ConextCRM permite que cada trabajador fiche su entrada y salida con su propia contraseña, garantizando que ficha él y no un compañero. Es el registro de jornada, obligatorio por ley para todo negocio con empleados.",
      "Lo que cierra la venta: NO usa huella ni reconocimiento facial. La AEPD prohíbe la biometría para fichar (multas de hasta 365.000 €), así que muchos sistemas con huella están fuera de la ley; el nuestro cumple.",
      "El historial solo lo ve el administrador (protegido con contraseña), la hora la sella el servidor y los registros son inalterables. En el simulador (sección Fichajes) puedes enseñárselo al cliente tal cual lo verá en su negocio.",
    ],
  },
  {
    version: "1.27.0",
    date: "2026-06-16",
    title: "Demo: cartilla de fidelización en Bonos (\"cada X sesiones, una de regalo\")",
    tag: "novedad",
    items: [
      "Nuevo tipo de bono en el simulador de Bonos: la Cartilla de fidelidad. Se la activas al cliente que tú quieras y cada vez que reserva una cita se le suma un sello automáticamente; al completar la cartilla (p. ej. 10) se marca una sesión de regalo y el contador empieza de nuevo.",
      "Úsalo como argumento de venta: es el clásico \"cada 10 cortes, uno gratis\" pero automático, y el cliente ve su progreso en el ticket de confirmación de la cita por WhatsApp.",
      "En la demo puedes crear la cartilla, ver el progreso y canjear la sesión de regalo, igual que lo verá el negocio en su CRM.",
    ],
  },
  {
    version: "1.26.0",
    date: "2026-06-16",
    title: "Tablas de competencia revisadas: nuevas filas de VeriFactu y control de fichajes",
    tag: "novedad",
    items: [
      "Las tablas de comparación con la competencia tienen dos filas nuevas con las que cerrar ventas. La primera: \"Sistema de facturación VeriFactu (Hacienda)\". VeriFactu es la nueva normativa antifraude obligatoria en 2027 (1 de enero para empresas, 1 de julio para autónomos) que TODO negocio que facture tendrá que cumplir. ConextCRM ya lo lleva integrado; aprovéchalo como argumento de urgencia.",
      "La segunda fila nueva: \"Control de trabajadores (fichaje de entradas y salidas)\". ConextCRM permite fichar la entrada y la salida de cada trabajador con historial por fechas (registro de jornada, también obligatorio por ley). Reemplaza a la antigua fila \"Recomendado para\".",
      "Hemos verificado competidor por competidor en sus webs oficiales antes de poner cada Sí/No. Cuando un competidor no publica si lo tiene, la celda dice \"No se indica en su web\" en lugar de afirmar nada: si el cliente te pregunta, esa es la respuesta honesta y no te juegas la credibilidad.",
      "Resumen rápido por si te lo preguntan: con VeriFactu integrado salen Conext, Fresha, Square, Wilapp, Flowww, Doctoralia y Nubimed. Con fichaje de trabajadores: Conext, Booksy, Fresha, Square, Wilapp, Vagaro, MindBody y Flowww. Booksy y Treatwell, por ejemplo, no indican VeriFactu en su web.",
      "Cambios aplicados a las tablas de Barbería, Peluquería, Estética, Lavadero, Salud, Spa, Consultoría, Despacho de Abogados, Autoescuela y Otro. (Marketing de bares y Pedidos se mantienen igual porque ahí ni la facturación VeriFactu ni el fichaje son funciones de esos competidores.)",
    ],
  },
  {
    version: "1.25.1",
    date: "2026-06-15",
    title: "El perfil de la empresa ahora también se abre desde Ajustes de empresa",
    tag: "mejora",
    items: [
      "Ya puedes abrir la ficha del negocio (datos de facturación, gestoría, serie, plan y preferencias) desde dos sitios: el círculo del perfil de abajo a la izquierda como hasta ahora, o el nuevo botón \"Ver perfil de empresa\" en Ajustes de empresa.",
    ],
  },
  {
    version: "1.25.0",
    date: "2026-06-14",
    title: "Nuevo: el lead puede pedirte una presentación desde el WhatsApp del Flow",
    tag: "novedad",
    items: [
      "El Flow ahora se puede enviar con un botón extra: \"Solicitar presentación\". En el LeadEditModal tienes el botón morado \"Flow + presentación\" (junto a \"Enviar Flow\"). El lead recibe la mini con DOS botones: \"Solicitar presentación\" y \"Simulador de cita\".",
      "Al pulsar \"Solicitar presentación\", al lead se le abre un formulario dentro de WhatsApp para reservar una demo comercial (unos 30 min) viendo la disponibilidad real del vendedor que tiene asignado: elige día, hora y escribe el nombre de su negocio.",
      "Cuando reserva, le llega al instante a SU WhatsApp un mensaje con los detalles de la cita (fecha, hora y con quién) y el teléfono de su comercial por si quiere cambiarla. Además, al vendedor asignado le llega otro WhatsApp avisándole del nombre del negocio y la fecha, y la cita le aparece en su calendario.",
      "En la vista previa del Flow (botón del ojo) ahora puedes pulsar \"Solicitar presentación\" y recorrer TODAS las pantallas del formulario tal cual las verá el lead en su móvil: día → hora → nombre del negocio → confirmación. Úsalo para enseñárselo en la demo.",
    ],
  },
  {
    version: "1.24.5",
    date: "2026-06-13",
    title: "Las citas de prueba del simulador ya salen desde el número de Conext de cada sector",
    tag: "novedad",
    items: [
      "Cuando enseñas el simulador y reservas una cita de prueba, la confirmación por WhatsApp ahora llega desde el número de Conext del SECTOR del cliente (barbería, peluquería, estética o lavadero), no desde un número genérico. Para el cliente se ve idéntico a como le llegaría a sus propios clientes.",
      "El mensaje sale con el nombre del negocio del lead y su ticket/recordatorio, igual que una reserva real. Así la demo es mucho más creíble: \"mira, esto es exactamente lo que recibe tu cliente\".",
      "El número del cliente queda dado de alta automáticamente para el simulador: puede seguir escribiendo a ese número de Conext y probar a coger más citas él mismo. Sectores sin número propio siguen saliendo desde el número principal de Conext.",
    ],
  },
  {
    version: "1.24.0",
    date: "2026-06-12",
    title: "Ten clara la respuesta: ¿cómo le piden cita por WhatsApp a un negocio sus clientes?",
    tag: "novedad",
    items: [
      "Pregunta clave que te pueden hacer: \"¿y cómo coge cita por WhatsApp un cliente mío?\". Respuesta corta: el negocio recibe SU enlace de reserva en su propio WhatsApp y desde ahí lo reparte a sus clientes (chat, grupos, estados). Cuando un cliente pulsa el enlace, le escribe al número de Conext del sector y reserva; el enlace lleva un código que identifica a ese negocio para asignarle la cita.",
      "Lo importante: el negocio NO tiene que pelearse para copiar el enlace. En el Calendario → \"Ver enlace de reserva\" (y en Administración → WhatsApp) hay un botón nuevo \"Enviármelo a mi WhatsApp\": el negocio lo pulsa y le llega el enlace a su WhatsApp. A partir de ahí lo va enviando a quien quiera.",
      "Las dos vías para explicárselo: (1) si tiene el CRM en un ordenador con WhatsApp Web abierto, puede copiar el enlace y enviarlo directo; (2) si usa el CRM en una tablet o un dispositivo sin WhatsApp, usa el botón \"Enviármelo a mi WhatsApp\" para recibirlo en el móvil y repartirlo desde ahí. Esta segunda es la que antes no quedaba clara.",
      "En la demo: entra en el Calendario → \"Ver enlace de reserva\". Enseña el cartel con el QR, el enlace copiable y el botón \"Enviármelo a mi WhatsApp\" (en el simulador simula el envío). Aclara cómo funciona el código: cuando el cliente abre el enlace, le sale en su WhatsApp un mensaje ya escrito con el código entre paréntesis y solo le da a enviar; el negocio no toca nada, solo conviene que avise a sus clientes de que no borren ese texto entre paréntesis (es lo que asigna la cita a ese negocio).",
      "También nuevo: el botón \"Cambiar número\" (junto al enlace y en el aviso de Clientes) deja al negocio actualizar el número al que le mandamos el enlace, por si en ese número no tiene WhatsApp. Enséñalo en la demo.",
    ],
  },
  {
    version: "1.23.0",
    date: "2026-06-11",
    title: "Demuestra en el simulador el nuevo importador de facturas con IA del Almacén",
    tag: "novedad",
    items: [
      "El Almacén del simulador ya incluye la nueva función estrella: importar productos subiendo la factura del proveedor. El botón Importar luce un distintivo \"IA\" animado y dentro hay dos modos: el clásico CSV/Excel y el nuevo \"Factura con IA\" (beta).",
      "Para demostrarlo al cliente: entra en Almacén → Importar → elige \"Factura con IA\" y haz clic en la zona de subida. El simulador hace como que procesa una factura y extrae 4 productos con cantidades y costes: dos que ya existen en el almacén (verás cómo suma el stock) y dos nuevos donde el cliente pondría su precio de venta.",
      "Puedes pulsar \"Añadir factura\" para simular que se suben varias facturas seguidas y rematar con \"Importar\": los productos aparecen en el almacén de la demo al momento.",
      "El argumento de venta: el cliente deja de teclear su inventario a mano; sube la factura de su proveedor (PDF o foto) y la IA le rellena los productos con su coste real, descuentos incluidos.",
    ],
  },
  {
    version: "1.22.0",
    date: "2026-06-11",
    title: "Reenviar Flow y ver quién y cuándo envió la tarjeta o el Flow",
    tag: "mejora",
    items: [
      "El botón Enviar Flow ahora funciona como el de la tarjeta: si ya se lo enviaste a un lead, pasa a \"Reenviar Flow\" y puedes mandárselo otra vez (te pide confirmación para que no se escape un envío de más).",
      "Tanto en la tarjeta como en el Flow aparece un chip con el nombre del trabajador que lo envió y la fecha del último envío.",
      "Si se ha enviado varias veces, al pasar el ratón por encima ves el historial completo: quién lo envió y en qué fecha cada vez.",
    ],
  },
  {
    version: "1.21.0",
    date: "2026-06-11",
    title: "Ahora ves de un vistazo cuántos leads de cada lista has visitado",
    tag: "mejora",
    items: [
      "En Contactos por Grupos, a la derecha de cada lista verás cuántos leads has visitado sobre el total, sin tener que desplegarla ni ir uno por uno. Por ejemplo, una lista de 3 leads en la que no has visitado a nadie mostrará \"Visitados 0/3\".",
      "Un lead cuenta como visitado en cuanto tiene seguimiento: un estado de interés (interesado, no interesado, etc.) o una nota. Así sabes al momento cuántos te faltan por visitar de cada lista.",
      "Cuando ya has visitado a todos los leads de una lista, en vez del contador aparece un \"Lista visitada\" con un check verde grande, para que veas de un golpe que esa lista la tienes terminada.",
    ],
  },
  {
    version: "1.20.0",
    date: "2026-06-10",
    title: "Sube las grabaciones de tus visitas y llamadas a la ficha del lead",
    tag: "novedad",
    items: [
      "Ahora puedes grabarte con el móvil durante una visita o una llamada y subir el audio a la ficha del lead desde el navegador del propio teléfono: abre la ficha, en la columna de Seguimiento elige si es Visita o Llamada, añade una nota si quieres y pulsa para subir el archivo.",
      "Puedes subir tantas grabaciones como visitas o llamadas le hayas hecho a ese contacto: se numeran solas (Visita 1, Visita 2, Llamada 1…). No te limita a una.",
      "Vale cualquier archivo de audio, así que funciona igual desde un iPhone que desde un Android.",
      "Las grabaciones se escuchan desde la misma ficha del lead, con un botón de reproducir en cada una.",
      "En el listado de contactos, los leads que tengan grabaciones lo indican con un chip, para que los localices de un vistazo.",
    ],
  },
  {
    version: "1.19.0",
    date: "2026-06-10",
    title: "Nuevo mensaje inicial del Flow + VeriFactu incluido",
    tag: "novedad",
    items: [
      "Hemos renovado el mensaje inicial del Flow para peluquería, barbería y estética: más directo y comercial (control de citas y tiempos, citas online, recordatorios por WhatsApp, facturación adaptada a VeriFactu y control horario). Míralo tal y como le llega al cliente con el ojo de \"Vista previa del Flow\" en la ficha de un lead.",
      "Ya se incluye VeriFactu: en Configuración → VeriFactu puedes enseñar la facturación remitida a la AEAT y, si el certificado lo tiene la gestoría, enviarle las instrucciones con un ojo de vista previa del email que recibiría.",
    ],
  },
  {
    version: "1.18.0",
    date: "2026-06-10",
    title: "Nuevo argumento de venta: contraseña para la sección Administración",
    tag: "novedad",
    items: [
      "Argumentario: muchos negocios dejan la sesión abierta en el tablet o el ordenador del mostrador para que los empleados usen el calendario. El problema es que cualquiera puede colarse en Facturación, ajustes o datos de suscripción. Con esta novedad el dueño activa una contraseña que se pide CADA VEZ que alguien intenta entrar en Administración, aunque la sesión ya esté iniciada.",
      "En la demo: entra en Configuración → pestaña de ajustes → tarjeta del candado. Activa la contraseña (en la demo acepta cualquier texto como confirmación), sal de la página y vuelve a entrar en Administración: pedirá la contraseña antes de mostrar nada. Luego muestra que desde la misma tarjeta se puede cambiar o eliminar (siempre confirmando la contraseña de login del administrador; en la demo también vale cualquier texto).",
      "Si el cliente pregunta \"¿y si se me olvida?\": en la pantalla del candado hay un \"¿Has olvidado la contraseña?\" que lo quita confirmando la contraseña de login del administrador (enséñalo en la demo, también acepta cualquier texto). Nadie se queda fuera de su propio negocio.",
      "Recalca que es completamente opcional y no cambia nada para quien no la active, y que en la app real la confirmación valida la contraseña de login del administrador.",
    ],
  },
  {
    version: "1.17.1",
    date: "2026-06-10",
    title: "Ya puedes reenviar la tarjeta de visita a un lead",
    tag: "mejora",
    items: [
      "Antes, si ya le habías enviado la tarjeta a un lead, el botón se quedaba bloqueado. Ahora pasa a \"Reenviar Tarjeta\" y puedes mandársela otra vez las veces que haga falta (te pide confirmación para que no se te escape un envío de más).",
    ],
  },
  {
    version: "1.17.0",
    date: "2026-06-10",
    title: "La tarjeta de visita ahora lleva al cliente a TU WhatsApp directo",
    tag: "mejora",
    items: [
      "Hemos cambiado el texto y la tarjeta que envías: en vez de \"escríbeme por aquí\" (que iba al número de Conext), ahora el cliente ve tu número directo para escribirte o llamarte, y el QR de la tarjeta también lleva a tu WhatsApp.",
      "Antes de enviarla puedes ver cómo le llega: pulsa el ojo de \"Vista previa\" junto a \"Enviar Tarjeta\" en la ficha del lead.",
    ],
  },
  {
    version: "1.16.0",
    date: "2026-06-10",
    title: "No tendrás que volver a iniciar sesión durante la jornada",
    tag: "mejora",
    items: [
      "Antes la sesión se cerraba sola y tenías que volver a meter usuario y contraseña, a veces en mitad de una demo o una visita. Ahora se mantiene abierta mucho más tiempo.",
      "Menos interrupciones mientras enseñas ConextCRM a un cliente.",
    ],
  },
  {
    version: "1.15.1",
    date: "2026-06-10",
    title: "Tablas de competencia: precio de ConextCRM corregido",
    tag: "arreglo",
    items: [
      "En las tablas de competencia el precio de ConextCRM aparecía mal (30€/49€ según el sector). Ahora muestra el precio real: 40€/mes (50€/mes en restauración y pedidos).",
      "El \"incluido\" se aclara: 1.000 confirmaciones de cita y recordatorios automáticos por WhatsApp al mes.",
    ],
  },
  {
    version: "1.15.0",
    date: "2026-06-10",
    title: "Reenviar los accesos del cliente por WhatsApp cuando quieras",
    tag: "novedad",
    items: [
      "Hasta ahora solo podías mandar las credenciales por WhatsApp en el momento de crear los accesos. Ahora, en la ficha del lead, al pulsar el ojo de \"Accesos del cliente\" tienes un botón verde para enviárselas (o reenviárselas) por WhatsApp cuando lo necesites.",
      "Útil cuando el cliente dice \"no me llegó\" o \"se me han perdido\": entras en sus accesos ya creados y se los reenvías al instante, sin tener que volver a crear la cuenta.",
      "Usa la misma plantilla de siempre (usuario, contraseña y enlace app.conextcrm.es) y deja el lead marcado como \"Accesos enviados\".",
    ],
  },
  {
    version: "1.14.0",
    date: "2026-06-10",
    title: "Importar y exportar el almacén: adiós a la excusa de \"tengo todo en otro programa\"",
    tag: "novedad",
    items: [
      "Argumentario: el mayor freno para cambiar de programa es \"tengo mi inventario en otro sitio\". Ahora el cliente importa su almacén desde un Excel/CSV de cualquier CRM y empieza con su catálogo cargado en minutos, sin teclear nada a mano.",
      "En la demo: entra en Almacén → Productos y enseña los botones \"Exportar\" (saca todo a Excel o CSV) e \"Importar\". Al importar, muestra el paso de emparejar columnas (su columna \"PVP\" = nuestro \"Precio\", etc.): funciona venga de donde venga el archivo.",
      "Remata con dos ventajas: si un producto ya existe (mismo nombre) se actualiza en vez de duplicarse, y hay una vista previa antes de confirmar. Todo en el simulador es de prueba, sin tocar datos reales.",
    ],
  },
  {
    version: "1.13.0",
    date: "2026-06-10",
    title: "Cada factura cuenta para un trabajador: comisiones y rendimiento",
    tag: "novedad",
    items: [
      "Argumentario: muchos negocios pagan comisión o quieren saber qué profesional vende más. Ahora cada factura (cita, almacén o bono) queda atribuida a un trabajador y el dueño ve en Facturación cuánto factura cada uno.",
      "En la demo: al generar una factura elige el trabajador (en las citas ya sale puesto el de la cita y se puede cambiar); luego entra en Administración → Facturación, usa el filtro \"Trabajador\" y enseña el desglose por persona.",
      "Recalca que ese dato es interno y NO sale en la factura del cliente: sirve para comisiones, objetivos y medir el rendimiento de cada trabajador.",
    ],
  },
  {
    version: "1.12.1",
    date: "2026-06-10",
    title: "La sección \"Configuración\" ahora se llama \"Administración\"",
    tag: "mejora",
    items: [
      "En el menú lateral del simulador, \"Configuración\" pasa a llamarse \"Administración\" y estrena icono (un edificio en vez del engranaje), igual que verá el cliente en su CRM.",
      "Solo cambia el nombre y el icono: dentro está exactamente todo lo de siempre y en el mismo sitio. No tienes que reaprender nada para la demo.",
    ],
  },
  {
    version: "1.12.0",
    date: "2026-06-10",
    title: "Pruébalo tú mismo: flujo completo de \"Suscribirse al Plan Pro\"",
    tag: "novedad",
    items: [
      "Ya puedes recorrer de principio a fin el flujo de suscripción: pulsa \"Suscribirse al Plan Pro\" en Configuración y verás la tarjeta de precio del sector, las tres formas de empezar, el formulario de datos fiscales, el contrato y el pago en Stripe.",
      "Es TODO un entorno de pruebas: puedes incluso completar el pago con una tarjeta de test (4242 4242 4242 4242, cualquier fecha futura y cualquier CVC). No tiene ningún efecto real ni se cobra nada.",
      "Úsalo para conocer de primera mano exactamente lo que verá el cliente al suscribirse y enseñarlo con seguridad en las demos.",
    ],
  },
  {
    version: "1.11.0",
    date: "2026-06-10",
    title: "Suscribirse a Pro: ahora con prueba gratis aunque deje la tarjeta",
    tag: "novedad",
    items: [
      "Al darle a \"Suscribirse a Pro\", el cliente elige cómo empezar entre tres opciones: pagar ya (prorrateo de lo que queda de mes), prueba gratis hasta el día 1 del mes siguiente, o prueba gratis por los días reales que le queden de su prueba de 30 días.",
      "Argumentario: ya puedes cerrar la venta y dejar puesto el método de pago en el momento SIN cobrarle nada hoy. Le regalas la prueba hasta el día 1 (o los días que le resten) y el primer cobro se hace solo cuando empieza a pagar de verdad.",
      "Mientras dura la prueba el negocio sigue en modo prueba (solo confirmación y recordatorios); el plan Pro completo se activa con el primer cobro. Las opciones salen tanto en plan mensual como anual.",
    ],
  },
  {
    version: "1.10.2",
    date: "2026-06-09",
    title: "Configurar horarios de trabajador, más fácil de enseñar",
    tag: "mejora",
    items: [
      "Argumento: al configurar el horario de un trabajador ya sale puesta una pausa de mediodía (14:00–15:00), así el cliente ve al instante cómo se parte la jornada en mañana y tarde sin tener que adivinar cómo añadir un segundo tramo.",
      "Cada pausa dice claramente cuál es el \"Inicio de la pausa\" y cuál su \"Duración\", y un aviso explica que arriba se pone el horario general de la semana y abajo se afina día a día.",
      "En la demo: cuando creas un trabajador ahora aparece en pantalla durante toda la sesión (al cerrar el simulador se borra). Antes parecía que no se guardaba.",
    ],
  },
  {
    version: "1.10.1",
    date: "2026-06-09",
    title: "El código del enlace de reserva ahora es corto y bonito",
    tag: "mejora",
    items: [
      "Argumento: el enlace de \"pedir cita por WhatsApp\" lleva un código corto y limpio (2 letras), nada de códigos largos que asustan al cliente.",
      "Tranquiliza al negocio: los enlaces y QR que ya tenga repartidos siguen funcionando, esto no rompe nada.",
    ],
  },
  {
    version: "1.10.0",
    date: "2026-06-09",
    title: "Nueva sección \"Facturación\": toda la facturación del negocio por días",
    tag: "novedad",
    items: [
      "La sección \"Citas\" pasa a llamarse \"Facturación\" y reúne las facturas de citas y de ventas de almacén, día a día.",
      "Pestaña \"Todas\": total del día, desglose por origen y reimpresión de cualquier factura.",
      "Toda venta de almacén genera su factura automáticamente; el historial de ventas solo las muestra.",
    ],
  },
  {
    version: "1.9.0",
    date: "2026-06-08",
    title: "Nuevo gancho: consentimientos RGPD con firma del cliente",
    tag: "novedad",
    items: [
      "El cliente firma los consentimientos (RGPD) con el dedo en su propia ficha al darse de alta —opcional, también se puede firmar después.",
      "Cada negocio configura sus cláusulas (datos, comunicaciones comerciales y las que quiera) desde ajustes de empresa.",
    ],
  },
  {
    version: "1.8.2",
    date: "2026-06-07",
    title: "Recordatorio de cita: por defecto solo 24h antes",
    tag: "mejora",
    items: [
      "En los sectores de citas, las empresas nuevas tienen por defecto un único recordatorio a 24h antes (antes eran 24h + 2h). Se puede cambiar en cualquier momento.",
    ],
  },
  {
    version: "1.8.1",
    date: "2026-06-07",
    title: "Intercalado: el bloque de \"Espera\" ahora se llama \"Exposición\"",
    tag: "mejora",
    items: [
      "En el intercalado de servicios, el tiempo de espera pasa a llamarse \"exposición\" (más claro para tintes, mascarillas, etc.).",
    ],
  },
  {
    version: "1.8.0",
    date: "2026-06-06",
    title: "Ya puedes ofrecer VeriFactu (facturación verificada con la AEAT)",
    tag: "novedad",
    items: [
      "Gancho nuevo: el cliente cumple con Hacienda (VeriFactu) desde el propio CRM, sin software aparte.",
      "Si el certificado lo tiene su gestor, un botón \"Enviar instrucciones a la gestoría\" le manda un enlace seguro para subirlo él, sin entrar al CRM.",
    ],
  },
  {
    version: "1.7.1",
    date: "2026-06-06",
    title: "Tablas de competencia actualizadas al modelo \"WhatsApp desde el número de ConextCRM\"",
    tag: "mejora",
    items: [
      "El argumentario de las comparativas ya no dice \"desde tu propio número\": ahora el gancho es \"número oficial de ConextCRM verificado por Meta, listo desde el primer día y sin tener que dar de alta tu número\".",
      "Quitada la pulla de \"ellos usan número compartido\" contra Checkfy y Flowww (Conext también envía desde el número de ConextCRM). Ahora se les critica por lo que sí es cierto: bolsa de mensajes limitada (Checkfy) y WhatsApp solo como add-on de pago (Flowww).",
      "Añadida una nueva competencia en la tabla de Peluquería: \"Manager en la Nube\" (AAR Software) — software de gestión clásico con avisos por SMS y reserva en web propia, desde 22,70€/mes.",
    ],
  },
  {
    version: "1.7.0",
    date: "2026-06-06",
    title: "Campañas automáticas reunidas en \"Servicios y Personal\" (mejor para demos)",
    tag: "novedad",
    items: [
      "Las campañas automáticas se han movido a \"Servicios y Personal\" → \"Campañas automáticas\": las 4 juntas (confirmación, recordatorio, aviso de cambio de cita y rellenar huecos), cada una con su configuración y vista previa. En el simulador se enseña igual.",
      "Argumentario: el cliente las ve activas desde el primer día, sin tener que conectar su número de WhatsApp.",
      "El aviso de cambio de cita y el de rellenar huecos ya salen también desde el número de ConextCRM durante la prueba.",
    ],
  },
  {
    version: "1.6.0",
    date: "2026-06-06",
    title: "Factura sin cita previa desde el calendario (nuevo gancho para demos)",
    tag: "novedad",
    items: [
      "Novedad en los sectores de citas: botón \"Facturar\" en el calendario para cobrar a un cliente que llega sin cita.",
      "Se elige el cliente (o a mano), se añaden servicios con precio/cantidad/descuento y, si se quiere, productos del almacén, todo en una sola factura. En el simulador funciona igual para enseñarlo.",
      "Argumentario: ideal para el cliente de paso (barberías, estética, peluquerías). Cobran y facturan al momento sin crear la cita antes.",
    ],
  },
  {
    version: "1.5.1",
    date: "2026-06-06",
    title: "Días festivos: cierra rangos de días (mejora para demos)",
    tag: "mejora",
    items: [
      "En \"Trabajadores y festivos\" ahora se abre primero la pestaña \"Días festivos\".",
      "Para vacaciones o cierres puedes elegir fecha de inicio y fin y cerrar todo el rango de golpe (p.ej. una semana). En el simulador, dentro de \"Trabajadores\" → \"Días festivos\".",
      "Al pulsar \"Añadir\" aparece un aviso de confirmación y la lista baja hasta el día o rango recién añadido. Buen gancho para negocios que cierran por vacaciones.",
    ],
  },
  {
    version: "1.5.0",
    date: "2026-06-05",
    title: "\"Supervisión de tablets\" pasa a \"Supervisión de pruebas\"",
    tag: "mejora",
    items: [
      "La sección \"Supervisión de tablets\" ahora se llama \"Supervisión de pruebas\".",
      "Ya no muestra solo los leads con tablet entregada: aparece cualquier lead al que le hayas creado accesos, tenga tablet o no. Así puedes seguir el uso de la prueba de todos tus clientes.",
      "Cada vendedor ve únicamente los leads cuyos accesos creó él.",
    ],
  },
  {
    version: "1.4.0",
    date: "2026-06-04",
    title: "Novedad en Citas: saldo pendiente de clientes",
    tag: "novedad",
    items: [
      "Citas ya permite anotar lo que debe cada cliente y filtrar a los deudores.",
      "Demuéstralo en el simulador, sector citas.",
    ],
  },
  {
    version: "1.3.0",
    date: "2026-06-04",
    title: "Descuentos por producto y vista previa de la factura",
    tag: "novedad",
    items: [
      "En la factura de una cita, al añadir un producto del almacén ahora se puede meter un descuento: porcentaje libre de 0 a 100. Se ve el precio tachado y el final, y la factura refleja el descuento.",
      "Los productos vendidos con descuento salen marcados con el porcentaje en el historial de ventas del Almacén.",
      "Nuevo botón \"Vista previa\" en el bloque de factura: enseña cómo quedará el PDF (ticket o A4) antes de generarlo. En el simulador funciona igual: úsalo en las demos para mostrar la factura sin emitir nada.",
      "Argumentario: ideal para negocios que hacen promociones o packs (peluquerías, estética, barberías). Pueden cobrar servicio + producto con descuento en una sola factura, y enseñarla al cliente antes.",
    ],
  },
  {
    version: "1.2.0",
    date: "2026-06-03",
    title: "Días festivos y cierres del negocio (nuevo argumento para demos)",
    tag: "novedad",
    items: [
      "Novedad en los sectores de citas: la pantalla \"Trabajadores\" pasa a \"Trabajadores y festivos\" con una pestaña nueva donde el negocio elige su comunidad autónoma y ve todos los festivos del año (y del siguiente).",
      "Por cada festivo el negocio decide si abre o cierra; los cerrados (por defecto) dejan de ofrecerse a los clientes al pedir cita por WhatsApp. También puede añadir festivos locales a mano.",
      "En el simulador puedes enseñarlo: dentro de \"Trabajadores\", pestaña \"Días festivos\". Gancho ideal para barberías, peluquerías y estética, que cierran en festivos y no quieren recibir citas esos días.",
      "Para tu argumentario: al cerrar un festivo se bloquea la agenda de TODOS los profesionales ese día, incluidos los trabajadores que se den de alta más adelante. Cero mantenimiento para el cliente.",
    ],
  },
  {
    version: "1.1.0",
    date: "2026-06-03",
    title: "Vender productos al facturar una cita y nueva ficha del cliente",
    tag: "novedad",
    items: [
      "En el simulador de los sectores de citas, al generar la factura de una cita ahora puedes añadir productos del almacén para el mismo cliente y emitir una factura combinada (servicio + productos).",
      "Las ventas aparecen en el historial del Almacén ya marcadas como facturadas, igual que lo verá el cliente en la app real.",
      "En la app real, los clientes del negocio con más de una cita reservada reciben un botón \"Ver mi ficha\" en la confirmación y el recordatorio de WhatsApp, con sus próximas citas (y la periodicidad de las fijas), sus bonos y el saldo. Buen argumento para enseñarlo en las demos.",
    ],
  },
  {
    version: "1.0.0",
    date: "2026-06-03",
    title: "Estrenamos el historial de novedades",
    tag: "novedad",
    items: [
      "A partir de ahora, cada vez que mejoremos la herramienta te lo contaremos aquí: las novedades aparecerán solas al entrar.",
      "Podrás volver a consultarlas cuando quieras: pulsa el círculo de tu perfil (en la barra lateral) y luego el número de versión.",
    ],
  },
];

export const APP_VERSION = CHANGELOG[0]?.version || "1.0.0";
